import { render } from "./LibraryFilterComponent.vue?vue&type=template&id=06d8429e&scoped=true&ts=true"
import script from "./LibraryFilterComponent.vue?vue&type=script&lang=ts"
export * from "./LibraryFilterComponent.vue?vue&type=script&lang=ts"

import "./LibraryFilterComponent.vue?vue&type=style&index=0&id=06d8429e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d8429e"]])

export default __exports__